/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Tools_TitleInputs */

const en_directory_footer_tools_title = /** @type {(inputs: Directory_Footer_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Tools`)
};

const zh_directory_footer_tools_title = /** @type {(inputs: Directory_Footer_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 工具`)
};

/**
* | output |
* | --- |
* | "AI Tools" |
*
* @param {Directory_Footer_Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_tools_title = /** @type {((inputs?: Directory_Footer_Tools_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Tools_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_tools_title(inputs)
	return zh_directory_footer_tools_title(inputs)
});
export { directory_footer_tools_title as "directory.footer.tools_title" }